import RecentActivityInformation from './RecentActivityInformation'

export default RecentActivityInformation
